var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEyes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5029 60C25.42 60 31 46.8 31 30C31 13.2 25.42 0 15.5 0C5.27 0 0.000381739 13.2 0 30C0.000381739 46.8 5.27 60 15.5 60H15.5029Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5029 60C56.42 60 62 46.8 62 30C62 13.2 56.42 0 46.5 0C36.27 0 31.0004 13.2 31 30C31.0004 46.8 36.27 60 46.5 60H46.5029Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00094 44C10.2 44 12 39.6 12 34C12 28.4 10.2 24 7 24C3.7 24 2.00012 28.4 2 34C2.00012 39.6 3.7 44 7 44H7.00094Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0009 44C41.2 44 43 39.6 43 34C43 28.4 41.2 24 38 24C34.7 24 33.0001 28.4 33 34C33.0001 39.6 34.7 44 38 44H38.0009Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgEyes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eyes.393449573b9950e992f7e2c883f589ee.svg";